import { Component, Input } from '@angular/core';
import { PhotoInterface } from '@app/core/interfaces/photo.interface';

@Component({
    selector: 'ins-table-list-mobile',
    templateUrl: './table-list-mobile.component.html',
    styleUrls: ['./table-list-mobile.component.scss'],
})
export class TableListMobileComponent {
    @Input() loaded: boolean;
    @Input() photos?: PhotoInterface[] = [];
}
